export const convertArrayToObject = (array, key, value) => {
  const initialValue = {};
  return array.reduce((obj, item) => {
    return {
      ...obj,
      [item[key]]: item[value],
    };
  }, initialValue);
};

export const convertArrayToArrayOfString = (array, key) => {
  const initialValue = [];
  array.forEach((item) => {
    initialValue.push(item[key]);
  });

  return initialValue;
};

export function toCamelCase(str) {
  const string = str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    })
    .replace(/\s+/g, "");

  let newStr = "";
  if (string) {
    let wordArr = string.split(/[-_]/g);
    for (let i in wordArr) {
      if (i > 0) {
        newStr += wordArr[i].charAt(0).toUpperCase() + wordArr[i].slice(1);
      } else {
        newStr += wordArr[i];
      }
    }
  } else {
    return newStr;
  }
  return newStr;
}

export function sortAscendingOrder(arr) {
  const sorted = arr.sort((a, b) => a.order - b.order);
  return sorted;
}
export function capitalizeFLetter(string) {
  return string[0].toUpperCase() + string.slice(1);
}

export function formatDate(date, format = "mm/dd/yyyy") {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  switch (format) {
    case "mm/dd/yyyy":
      return `${month}/${day}/${year}`;
    case "yyyy/dd/mm":
      return `${year}/${day}/${month}`;
    case "yyyy/mm/dd":
      return `${year}/${month}/${day}`;
    case "dd/mm/yyyy":
      return `${day}/${month}/${year}`;
    case "dd/yyyy/mm":
      return `${day}/${year}/${month}`;
    default:
      return "Invalid format";
  }
}

export function calculateDistance(lat1, lon1, lat2, lon2) {
  function deg2rad(deg) {
    return deg * (Math.PI / 180);
  }
  const R = 6371; // Radius of the Earth in kilometers
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c; // Distance in kilometers
  return distance;
}

export function stringToURL(input) {
  return input.toLowerCase().replace(/ /g, "-");
}
